
import { isObject } from "lodash";
import axios from "axios";
import React  from 'react';
import styled from 'styled-components';
import Button from '@material-ui/core/Button';
import ClearIcon from '@material-ui/icons/Clear';
import IconButton from '@material-ui/core/IconButton';

import { Grid } from 'ui/Grid';
import {ContextFormControlWidget, ContextWidget} from 'form/Contexed';
import { InputWidget } from 'form/InputWidget';
import { ContactPersonForm } from './ContactPersonForm';
import { AsyncAutocompleteWidget } from 'form/AutocompleteWidget';
import UploadFileButton from "form/UploadFileInput";
import DaDataINNAutocomplete from "../../form/custom/DaDataINNAutocomplete";

const Index = styled.div`
  border: 1px solid #333333;
  border-radius: 2px;
  font-weight: bold;
  text-align: center;
  line-height: 24px;
`;

const StyledCounterpartyForm = styled.div`
  margin-bottom: 10px;
`;

const StyledHeader = styled.div`
  display: grid;
  grid-gap: 10px;
  grid-template-columns: 24px auto 1fr;
  align-items: center;
  margin-bottom: 10px;
  
  h3 {
    margin: 0;
    padding: 0;
    font-size: 16px;
  }
`;

const StyledBody = styled.div`
  margin-left: 10px;
  border-left: 1px solid #333333;
  padding: 20px 0 20px 20px;
`;


export function CounterpartyForm({index, counterparty, context}) {
  const fieldPath = `counterparties.${index}`;
  const item = context.getValue(fieldPath);

  const removeCounterparty = () => {
    if (counterparty.id) {
      context.setValue(`${fieldPath}.is_delete`, true);
    }
    else {
      context.removeArrayValue('counterparties', index)
    }
  };

  const uploadImage = (data, config) => {
    return axios.patch(counterparty.meta.url, data, config).then(res => {
      context.setValues({
        [`${fieldPath}.image_signature`]: res.data.image_signature,
        [`${fieldPath}.image_stamp`]: res.data.image_stamp,
      })
    })
  }

  const onFoundCounterpartyByINN = (data) => {
    if (typeof data === 'string') {
      context.setValue(`${fieldPath}.inn`, data);
    }
    else if (isObject(data)) {
      let updateValues = {};
      Object.keys(data).forEach(key => {
        if (!item[key] && data[key]) {
          updateValues[`${fieldPath}.${key}`] = data[key];
        }
      })
      context.setValues(updateValues);
    }
    else {
      context.setValue(`${fieldPath}.inn`, '');
    }
  }

  return (
    <StyledCounterpartyForm>
      <StyledHeader>
        <div>
          <Index>{index + 1}</Index>
        </div>
        <h3>Контрагент</h3>
        <div>
          {!item.id && (
            <>
              <React.Fragment>
                {(index !== 0 || context.item.counterparties.length > 1) && (
                  <IconButton size="small" onClick={() => removeCounterparty()}>
                    <ClearIcon />
                  </IconButton>
                )}
              </React.Fragment>
            </>
          )}
        </div>
      </StyledHeader>
      {!item.is_delete && (
        <StyledBody>
          <ContextWidget
            name={`${fieldPath}.name`}
            WidgetComponent={InputWidget}
            widgetProps={{
              label: 'Название',
              required: true
            }}
          />

          <ContextFormControlWidget
            name={`${fieldPath}.inn`}
          >
            <DaDataINNAutocomplete
              value={context.getValue(`${fieldPath}.inn`)}
              onChange={(value) => onFoundCounterpartyByINN(value)}
              textFieldProps={{
                label: 'ИНН',
                placeholder: 'Введите ИНН для поиска по контрагентам'
              }}
            />
          </ContextFormControlWidget>

          <ContextWidget
            name={`${fieldPath}.kpp`}
            WidgetComponent={InputWidget}
            widgetProps={{
              label: 'КПП'
            }}
          />

          <ContextWidget
            name={`${fieldPath}.head_name`}
            WidgetComponent={InputWidget}
            widgetProps={{
              label: 'ФИО руководителя',
            }}
          />

          <ContextWidget
            name={`${fieldPath}.head_post`}
            WidgetComponent={InputWidget}
            widgetProps={{
              label: 'Должность руководителя'
            }}
          />

          {item.id && (
            <Grid columns={'1fr 1fr'} mobileColumns={'1fr'} className={'mb-20'}>
              <div>
                {item.image_signature && (
                  <div className={'mb-10'}>
                    <img src={item.image_signature} width={'100px'} alt={'Подпись'} />
                  </div>
                )}
                <UploadFileButton label={'Подпись'} name={'image_signature'} patch={uploadImage} />
              </div>
              <div>
                {item.image_stamp && (
                  <div className={'mb-10'}>
                    <img src={item.image_stamp} width={'100px'} alt={'Печать'} />
                  </div>
                )}
                <UploadFileButton label={'Печать'} name={'image_stamp'} patch={uploadImage} />
              </div>
            </Grid>
          )}

          <ContextFormControlWidget
            name={`${fieldPath}.tariff`}
            WidgetComponent={AsyncAutocompleteWidget}
            widgetProps={{
              url: 'tariff',
              label: 'Тариф',
              optionLabel: 'name'
            }}
          />

          <ContextWidget
            name={`${fieldPath}.address`}
            WidgetComponent={InputWidget}
            widgetProps={{
              label: 'Юридический адрес',
              multiline: true
            }}
          />

          {counterparty.contacts && (
          <React.Fragment>
            {counterparty.contacts.map((contact, contactIndex) =>
              <ContactPersonForm
                key={contactIndex}
                index={contactIndex}
                counterpartyIndex={index}
                context={context}
                contact={contact}
              />
            )}
            </React.Fragment>
          )}

          <Button
            type="button"
            variant="outlined"
            onClick={() => context.pushArrayValue(`${fieldPath}.contacts`, {emails: []})}
          >
            + Добавить контактное лицо
          </Button>
        </StyledBody>
      )}
    </StyledCounterpartyForm>
  )
}
